import React, { useEffect } from "react";
import AppUtils from "@src/utils/appUtils";
import PropTypes from "prop-types";
import { useOperatorContext } from "@src/context/operatorContext";
import { DropDown } from "./";
import moment from "moment";
import { trackActionActivity } from "@src/utils/userActivityTracker";

const PeriodDropDown = ({ goalsData, minWidth, fullWidth }) => {
  const { profile, selectedPeriod, setSelectedPeriod } = useOperatorContext();
  const { customer } = profile;

  const periods = goalsData?.map((i) => i.groupKey) || [];

  const formattedPeriods = periods.map((p) => {
    const industryFormat =
      customer.industry === "shipping" ? "YYYY-MM-DD" : "YYYY-MM";

    if (!!p.to || typeof p !== "string") {
      return p;
    } else {
      const formatted = AppUtils.getDateRangeFromPeriodKey(p);
      const label =
        customer.industry === "shipping"
          ? `${moment.utc(formatted.from).format("MMM D, YYYY")} - ${moment.utc(formatted.to).format("MMM D, YYYY")}`
          : moment.utc(formatted.from).format("MMMM, YYYY");
      return {
        groupKey: p,
        value: p,
        to: formatted.to,
        from: formatted.from,
        enabled: true,
        industryFormatted: moment.utc(formatted.from).format(industryFormat),
        label,
      };
    }
  });

  const defaultPeriod = selectedPeriod || formattedPeriods[0];
  useEffect(() => {
    if (!selectedPeriod) setSelectedPeriod(defaultPeriod);
  }, [selectedPeriod]);

  if (!periods) return <p>No periods</p>;

  const options = formattedPeriods
    .filter((p) => !!p?.enabled)
    .map((period) => {
      return {
        value: period.industryFormatted,
        text: period.label,
      };
    });
  const handleDropdownChange = (e) => {
    const newPeriod = formattedPeriods.find((p) => p?.value === e);
    if (newPeriod) {
      trackActionActivity("PERIOD_DROPDOWN_SELECTION", {
        from: newPeriod.from,
        to: newPeriod.to,
        label: newPeriod.industryFormatted,
      });
      setSelectedPeriod(newPeriod);
    } else
      console.error(
        "PeriodDropDown can't find new period",
        e,
        formattedPeriods,
      );
  };

  return options ? (
    <DropDown
      fullWidth={fullWidth}
      minWidth={minWidth}
      options={options}
      value={selectedPeriod?.value || options[0]?.value}
      onChange={handleDropdownChange}
    />
  ) : null;
};

export const PeriodDropDownControls = {};

PeriodDropDown.propTypes = AppUtils.getPropTypeFromControls(
  PeriodDropDownControls,
);

export default PeriodDropDown;
